import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import styled from 'styled-components';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { H5 } from 'foundations-components/transitional/components/H5';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
//@ts-expect-error untyped
import CurrencySelect from 'ui-addon-i18n/components/CurrencySelect';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
//@ts-expect-error untyped
import { currencyStyles } from 'I18n/internal/utils/CurrencyLabelFormatters';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
//@ts-expect-error untyped
import FormattedCurrencyLabel from 'I18n/components/FormattedCurrencyLabel';
import { useBoardPanelPresentationContext } from '../context/BoardPanelPresentationContext';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurrencySelectOption = _ref => {
  let {
      children,
      option: {
        value
      }
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    currencyOptions
  } = useBoardPanelPresentationContext();
  const homeCurrencyCode = currencyOptions.homeCurrencyCode;
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: value === homeCurrencyCode ? /*#__PURE__*/_jsxs(View, {
      paddingBlock: "200",
      paddingInline: "500",
      as: "div",
      children: [/*#__PURE__*/_jsx(FormattedCurrencyLabel, {
        currencyCode: value,
        currencyStyle: currencyStyles.long
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "editCardsPanel.preferredCurrencySection.companyCurrency"
          })
        })
      })]
    }) : children
  }));
};
const PreferredCurrencySelect = () => {
  const {
    updateDraft,
    currencyOptions
  } = useBoardPanelPresentationContext();
  if (!currencyOptions) {
    return null;
  }
  const preferredCurrency = currencyOptions.preferredDisplayCurrency;
  const currencySettingsUrl = currencyOptions.settingsUrl;
  const onCurrencyChange = ({
    target: {
      value
    }
  }) => {
    updateDraft({
      preferredDisplayCurrencyPreferences: {
        preferredDisplayCurrency: value
      }
    });
  };
  if (!preferredCurrency) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 500
    });
  }
  return /*#__PURE__*/_jsx(CurrencySelect, {
    "data-selenium-test": "preferred-currency-dropdown",
    "data-test-id": "preferred-currency-dropdown",
    currenciesFilter: currencyOptions.filterCurrencies,
    currencyStyle: currencyStyles.long,
    dropdownFooter: /*#__PURE__*/_jsx(Button, {
      use: "link",
      external: true,
      href: currencySettingsUrl,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCardsPanel.preferredCurrencySection.editCurrenciesLink"
      })
    }),
    onChange: onCurrencyChange,
    optionComponent: CurrencySelectOption,
    value: preferredCurrency
  });
};
const LockedValue = ({
  children
}) => /*#__PURE__*/_jsxs("span", {
  children: [children, " ", /*#__PURE__*/_jsx(LockBadge, {})]
});
const LockedCurrencySelect = styled(CurrencySelect).withConfig({
  displayName: "PreferredCurrencySection__LockedCurrencySelect",
  componentId: "sc-18j06o7-0"
})(["*{cursor:pointer;}"]);
const LockedPreferredCurrencySelect = () => {
  const {
    currencyOptions
  } = useBoardPanelPresentationContext();
  const homeCurrencyCode = currencyOptions.homeCurrencyCode;
  const {
    openUpgradeModal
  } = useUpgradeModal('crm-pipelines-deal-preferred-currency-prefs');
  return /*#__PURE__*/_jsx(LockedCurrencySelect, {
    readOnly: true,
    value: homeCurrencyCode,
    currencyStyle: currencyStyles.long,
    onClick: openUpgradeModal,
    valueComponent: LockedValue
  });
};
const PreferredCurrencySection = () => {
  const {
    currencyOptions
  } = useBoardPanelPresentationContext();
  return /*#__PURE__*/_jsxs(PanelSection, {
    paddingInline: "0",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCardsPanel.preferredCurrencySection.title"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editCardsPanel.preferredCurrencySection.description"
    }), ' ', /*#__PURE__*/_jsx(HelpIcon, {
      alignWithText: true,
      "data-test-id": "help-icon",
      title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "editCardsPanel.preferredCurrencySection.helpText_jsx",
        elements: {
          UILink: Link
        },
        options: {
          href: currencyOptions.settingsUrl,
          external: true
        }
      }),
      tooltipProps: {
        maxInlineSize: `240px`
      }
    }), currencyOptions.active ? /*#__PURE__*/_jsx(PreferredCurrencySelect, {}) : /*#__PURE__*/_jsx(LockedPreferredCurrencySelect, {})]
  });
};
export default PreferredCurrencySection;